// extracted by mini-css-extract-plugin
export default {"inner":"ListItemSkeleton_inner_B512K"};